import { Component, OnInit, ElementRef, Renderer2, ViewRef, Type, Inject, ViewContainerRef } from '@angular/core';
import { WidgetComponent } from '../widget/widget.component';
import { MultiTableColumn } from '../table.column';

@Component({
	selector: 'app-table-widget-multicolumn',
	templateUrl: './multi-column.component.html',
	styleUrls: ['./multi-column.component.scss']
})
export class MultiColumnComponent extends WidgetComponent implements OnInit {

	viewContainerRef: ViewContainerRef;

	// tslint:disable-next-line: deprecation
	constructor(
		ngEl: ElementRef,
		renderer: Renderer2,
		@Inject(ViewContainerRef) viewContainerRef: ViewContainerRef
	) {
		super(ngEl, renderer);

		this.viewContainerRef = viewContainerRef;
	}

	ngOnInit() {
		const multiColumn: MultiTableColumn = this.tableColumn as MultiTableColumn;

		if (multiColumn.nested) {
			multiColumn.nested.forEach(column => {
				let cellComponent: Type<WidgetComponent> = null;

				if (column.type && typeof(column.type) !== typeof('')) {
					if (column.checker) {
						if (column.checker(this.tableElement.getData()) === true) {
							cellComponent = column.type;
						} else {
							if (column.checkerType) {
								cellComponent = column.checkerType;
							}
						}
					} else {
						cellComponent = column.type;
					}
				}

				if (cellComponent) {
					this.table.dynamicComponent.addComponent(cellComponent, this.table, this.tableElement, column);
				}
			});

			let index = 0;
			for (index = this.table.dynamicComponent.container.length - 1; index >= 0; index--) {
				const view: ViewRef = this.table.dynamicComponent.container.detach(0);

				this.viewContainerRef.insert(view);
			}

			this.table.dynamicComponent.resetContainer();
		}
	}

	public getContent() {
	}

}
